import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHttpCalls } from '../../../../../api/useHttpCalls';
import { useEagGridConfig } from '../../../../../context/useEagGridConfig';
import { useEagGridStore } from '../../../../../store/useEagGridStore';
import { SharePresetStateEnum } from '../../../../../types/SharePresetState';
import { buildSharePresetUrl } from '../../../../../utils/buildSharePresetUrl';
export const useSharePreset = onCloseCallback => {
  const $ = _c(12);
  const http = useHttpCalls();
  const store = useEagGridStore();
  const location = useLocation();
  const {
    buildAbsoluteUrl
  } = useEagGridConfig();
  const [shareUrl, setShareUrl] = useState(null);
  const [sharePresetState, setSharePresetState] = useState(SharePresetStateEnum.LOADING);
  let t0;
  if ($[0] !== onCloseCallback) {
    t0 = () => {
      onCloseCallback?.();
      setSharePresetState(SharePresetStateEnum.LOADING);
      setShareUrl(null);
    };
    $[0] = onCloseCallback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClose = t0;
  let t1;
  if ($[2] !== buildAbsoluteUrl || $[3] !== http || $[4] !== location || $[5] !== store) {
    t1 = () => {
      const gridCode = store.getState().gridCode;
      http.sharePreset({
        gridSettings: true,
        columnSettings: true,
        filters: true,
        order: true
      }).then(res => {
        setSharePresetState(SharePresetStateEnum.FINISHED);
        res?.sharedPresetId && buildAbsoluteUrl && setShareUrl(buildSharePresetUrl(buildAbsoluteUrl, gridCode, res.sharedPresetId, location.pathname));
      }).catch(() => {
        setSharePresetState(SharePresetStateEnum.ERROR);
      });
    };
    $[2] = buildAbsoluteUrl;
    $[3] = http;
    $[4] = location;
    $[5] = store;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const sharePreset = t1;
  let t2;
  if ($[7] !== onClose || $[8] !== sharePreset || $[9] !== sharePresetState || $[10] !== shareUrl) {
    t2 = {
      shareUrl,
      sharePresetState,
      sharePreset,
      onClose
    };
    $[7] = onClose;
    $[8] = sharePreset;
    $[9] = sharePresetState;
    $[10] = shareUrl;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};